export default __webpack_public_path__ + "static/media/logo01.b5fdeb2a.webp";